export default __webpack_public_path__ + "static/media/image.magicbit.633d00b6.png";